<template>
  <div id="app">
    <Header v-if="isShow && path !=='/login'"/>
    <div style="padding-top: 64px;height: calc(100% - 64px);">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <!--  绑定飞书  -->
    <bind-feishu/>
  </div>
</template>
<script>
import Header from './components/header/header'
// import config from './config/index'
import BindFeishu from "@/components/BindFeishu/index.vue";

export default {
  name: 'app',
  components: {BindFeishu, Header},
  data() {
    return {
      isShow: false,
      path: ''
    }
  },
  mounted() {
    // 站点浏览统计代码
    // this.path = this.$route.path;
    // const script = document.createElement('script')
    // script.src = `https://s95.cnzz.com/z_stat.php?id=${config.SITE_ID}&web_id=${config.SITE_ID}`
    // script.language = 'JavaScript'
    // document.body.appendChild(script)

    //访问浏览器友情提示
    let userAgent = navigator.userAgent
    const isChrome = userAgent.indexOf("Chrome") > -1;//判断是否Chrome浏览器
    if (!isChrome) {
      this.$notify({
        title: '友情提示',
        message: '当前使用的浏览器不是Chrome浏览器，为避免兼容性等问题建议改用Chrome浏览器',
        type: 'warning'
      })
    }
  },
  watch: {
    $route: {
      // eslint-disable-next-line
      handler: function (val, oldVal) {
        this.path = val.path;
        this.isShow = !val.meta.hide_menu
        if (window._czc) {
          let location = window.location
          let contentUrl = location.pathname + location.hash
          let refererUrl = '/'
          window._czc.push(['_trackPageview', contentUrl, refererUrl])
        }
      },
      deep: true
    }
  },
}
</script>
<style>
@import url('./assets/public.css');
@import url('./assets/common.css');
@import url('./assets/layout.css');
@import url('./assets/el-component-style.css');

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  height: 100%;
}

.m-icon {
  width: 2.4em;
  height: 2.4em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

</style>
